import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const EditAccountData = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M17.635 5.51341C18.265 6.16341 18.925 6.81341 19.565 7.44341C18.955 6.82341 18.265 6.16341 17.635 5.51341ZM18.775 3.84341C17.245 5.51341 15.365 7.35341 13.695 8.99341C13.4436 9.23353 13.2784 9.54987 13.225 9.89341C13.1278 10.5897 13.0678 11.2907 13.045 11.9934C13.7716 11.9752 14.4964 11.9118 15.215 11.8034C15.559 11.758 15.8768 11.5956 16.115 11.3434C17.705 9.67341 19.595 7.79341 21.215 6.26341C21.3622 6.13241 21.4754 5.96771 21.545 5.78341C21.6099 5.59392 21.6304 5.39208 21.605 5.19341C21.578 4.97917 21.5101 4.7721 21.405 4.58341C21.2862 4.3854 21.1339 4.20947 20.955 4.06341C20.7901 3.89932 20.6013 3.7611 20.395 3.65341C20.2106 3.54864 20.0062 3.4839 19.795 3.46341C19.6031 3.43317 19.4065 3.45386 19.225 3.52341C19.039 3.59048 18.8712 3.70006 18.735 3.84341H18.775Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M13.415 14.9134C15.0726 15.1598 16.7575 15.1598 18.415 14.9134"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M7.95498 11.0834C8.24672 11.0834 8.52651 10.9675 8.7328 10.7612C8.93909 10.5549 9.05498 10.2752 9.05498 9.98342C9.05498 9.69168 8.93909 9.4119 8.7328 9.20561C8.52651 8.99932 8.24672 8.88342 7.95498 8.88342C7.66324 8.88342 7.38345 8.99932 7.17716 9.20561C6.97087 9.4119 6.85498 9.69168 6.85498 9.98342C6.85498 10.2752 6.97087 10.5549 7.17716 10.7612C7.38345 10.9675 7.66324 11.0834 7.95498 11.0834Z"
      fill="currentColor"
    />
    <Path
      d="M5.26501 15.1034C5.26501 14.4005 5.54421 13.7265 6.04118 13.2295C6.53815 12.7326 7.21219 12.4534 7.91501 12.4534C8.61784 12.4534 9.29188 12.7326 9.78885 13.2295C10.2858 13.7265 10.565 14.4005 10.565 15.1034"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M22.835 9.99341C23.019 12.4571 22.8574 14.9345 22.355 17.3534C22.1771 18.1436 21.7634 18.8611 21.1688 19.4111C20.5742 19.961 19.8266 20.3175 19.025 20.4334C14.3377 21.1334 9.57236 21.1334 4.88501 20.4334C4.08734 20.3196 3.34265 19.9675 2.74846 19.4233C2.15427 18.879 1.7383 18.168 1.55501 17.3834C0.814996 13.8282 0.814996 10.1586 1.55501 6.60341C1.73297 5.81324 2.14661 5.09572 2.74122 4.54575C3.33583 3.99578 4.08339 3.63928 4.88501 3.52341C7.91298 3.07454 10.9767 2.91382 14.035 3.04341"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default EditAccountData;
